// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__36GO5","title":"Images90_title__3G2kr","images":"Images90_images__3QDPp"};